export default "__VITE_ASSET__d36yUiPa__"